"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ContentWithHeaderLayoutTemplate = _interopRequireDefault(require("../../../common/LayoutTemplates/ContentWithHeaderLayoutTemplate/ContentWithHeaderLayoutTemplate"));
var _EnableTwoFactorAuthContainerFactory = _interopRequireDefault(require("../../../EnableTwoFactorAuth/EnableTwoFactorAuthContainerFactory"));
var _EnableTwoFactorAuthComponent = _interopRequireDefault(require("./EnableTwoFactorAuth/EnableTwoFactorAuthComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var EnableTwoFactorAuthContainer = (0, _EnableTwoFactorAuthContainerFactory["default"])(_EnableTwoFactorAuthComponent["default"]);
var TwoFactorAuthSettingsCardComponent = function TwoFactorAuthSettingsCardComponent(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)("auth"),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement(_ContentWithHeaderLayoutTemplate["default"], {
    header: t("Two-Factor Authentication"),
    customClass: "profile-and-security-widget",
    classModifiers: ['sm']
  }, /*#__PURE__*/_react["default"].createElement(EnableTwoFactorAuthContainer, null));
};
var _default = exports["default"] = TwoFactorAuthSettingsCardComponent;